import React from 'react'
import { observer } from 'mobx-react-lite'

import List from '@mui/material/List'
import Stack from '@mui/material/Stack'

import { H3, P } from '@mxenabled/mxui'

import { useGlobalCopyStore, useSettingsStore, useWidgetLoadTimer } from '../../../common'
import { TransactionRule } from '../../../core'

import EditRuleAction from './actions/EditRuleAction'

const TransactionRulesTab = observer(() => {
  const { settings: settingsCopy } = useGlobalCopyStore()
  const { loadTransactionRules, transactionRules } = useSettingsStore()
  const [isTabInitialized, setIsTabInitialized] = React.useState(false)

  useWidgetLoadTimer({
    widgetName: 'TransactionRulesTab',
    isLoaded: isTabInitialized,
  })

  React.useEffect(() => {
    loadTransactionRules().finally(() => setIsTabInitialized(true))
  }, [])

  return (
    <Stack sx={{ gap: 24, py: 24 }}>
      <Stack sx={{ px: 24 }}>
        <H3>{settingsCopy.transaction_rules_label}</H3>
        <P variant="body1">{settingsCopy.transaction_rules_description}</P>
      </Stack>
      <List>
        {transactionRules.map((rule: TransactionRule, index: number) => (
          <EditRuleAction key={index} rule={rule} />
        ))}
      </List>
    </Stack>
  )
})

export default TransactionRulesTab
